/* eslint-disable prettier/prettier */
import React from 'react';
import ReactGanttChart from './BulkEmailGanttChart'; // Import the shared component

export default function GanttSchedulePage(): JSX.Element {
  return (   
      <>
        <h2 className="text-2xl font-semibold text-title  mb-[20px]">Bulk Email Schedule</h2>
        <ReactGanttChart />
      </>
  );
}